<template>
  <Modal v-bind="$attrs"
         ref="discardChangesModal"
         :title="tr('common.DISCARD_CHANGES')"
         :no-close-on-backdrop="true"
         :should-hide-header-close="true"
         :no-enforce-focus="true"
         :static="isStatic"
         :visible="visible"
         title-tag="h1"
         @hide="cancel">
    <p v-if="initialMode"
       v-html="tr('common.PREVENT_LOSS_CREATE')"></p>
    <p v-else> {{ tr('common.PREVENT_LOSS') }} </p>
    <template #modal-footer="{ hide }">
      <div>
        <ButtonGroup :primary-button-text="tr('portal.TX_CANCEL')"
                     :secondary-button-text="tr('common.DISCARD_CHANGES')"
                     primary-button-icon-name="cancel-circle"
                     secondary-button-icon-name="bin"
                     :primary-button-position="ButtonPosition.LEFT"
                     @primary-button-click="hide"
                     @secondary-button-click="discard">
        </ButtonGroup>
      </div>
    </template>
  </Modal>
</template>

<script>
  import ButtonGroup from './ButtonGroup.vue';
  import Modal from './Modal.vue';
  import ButtonPosition from '~/zf/frontend/common/layout/ButtonPosition';
  import { translator } from '~/zf/frontend/common/mixins';

  export default {
    name: 'DiscardModal',
    compatConfig: {
      MODE: 3,
    },
    components: { Modal, ButtonGroup },
    mixins: [translator],
    props: {
      initialMode: {
        type: Boolean,
        default: false,
      },
      isStatic: {
        type: Boolean,
        default: true,
      },
    },
    emits: ['discard'],
    expose: ['show', 'confirmDiscardChanges'],
    data() {
      return {
        ButtonPosition,
        resolve: null,
        visible: false,
      };
    },
    methods: {
      show() {
        this.visible = true;
      },
      confirmDiscardChanges() {
        this.show();
        return new Promise((resolve) => {
          this.resolve = resolve;
        });
      },
      cancel() {
        if (this.resolve !== null) {
          this.resolve(false);
        }
        this.visible = false;
      },
      discard() {
        this.$emit('discard');
        if (this.resolve !== null) {
          this.resolve(true);
        }
        this.visible = false;
      },
    },
  };
</script>
